import './ccf-app-health-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';


/* eslint-disable-next-line */
export interface CcfAppHealthIconProps extends SvgIconProps   {}

/**
 * CcfAppHealthIcon used to disply Network Health icon in the navigation panel
 * @param props - CcfAppHealthIconProps
 * @example -- <CcfAppHealthIcon />
 */
export function CcfAppHealthIcon(props: CcfAppHealthIconProps) {
  return (
    <SvgIcon {...props}>
      <path id="workforce-intelligence" d="M19,11a1,1,0,0,0,0-2H18V7h1a1,1,0,0,0,0-2H18V4.286A2.286,2.286,0,0,0,15.714,2H15V1a1,1,0,0,0-2,0V2H11V1A1,1,0,0,0,9,1V2H7V1A1,1,0,0,0,5,1V2H4.286A2.286,2.286,0,0,0,2,4.286V5H1A1,1,0,0,0,1,7H2V9H1a1,1,0,1,0,0,2H2v2H1a1,1,0,0,0,0,2H2v.714A2.286,2.286,0,0,0,4.286,18H5v1a1,1,0,0,0,2,0V18H9v1a1,1,0,0,0,2,0V18h2v1a1,1,0,0,0,2,0V18h.714A2.286,2.286,0,0,0,18,15.714V15h1a1,1,0,0,0,0-2H18V11Zm-3,4.714a.286.286,0,0,1-.286.286H4.286A.286.286,0,0,1,4,15.714V4.286A.286.286,0,0,1,4.286,4H15.714A.286.286,0,0,1,16,4.286Zm-2.712-6.2-2.816,4.707a.25.25,0,0,1-.465-.128h0V10.861H6.941a.25.25,0,0,1-.25-.25.245.245,0,0,1,.036-.129l2.815-4.7a.25.25,0,0,1,.465.128h0V9.14h3.066a.25.25,0,0,1,.25.25.245.245,0,0,1-.036.129Z" transform="translate(0)"/> 
    </SvgIcon>
  );
}

export default CcfAppHealthIcon;
